export function pseudoBlockifyMessages(messages: Record<string, any>): Record<string, any> {
  const blockified: Record<string, any> = {};
  const blockMap: Record<string, string> = {
    a: 'ａ', b: 'ｂ', c: 'ｃ', d: 'ｄ', e: 'ｅ', f: 'ｆ', g: 'ｇ', h: 'ｈ', i: 'ｉ', j: 'ｊ',
    k: 'ｋ', l: 'ｌ', m: 'ｍ', n: 'ｎ', o: 'ｏ', p: 'ｐ', q: 'ｑ', r: 'ｒ', s: 'ｓ', t: 'ｔ',
    u: 'ｕ', v: 'ｖ', w: 'ｗ', x: 'ｘ', y: 'ｙ', z: 'ｚ',
    A: 'Ａ', B: 'Ｂ', C: 'Ｃ', D: 'Ｄ', E: 'Ｅ', F: 'Ｆ', G: 'Ｇ', H: 'Ｈ', I: 'Ｉ', J: 'Ｊ',
    K: 'Ｋ', L: 'Ｌ', M: 'Ｍ', N: 'Ｎ', O: 'Ｏ', P: 'Ｐ', Q: 'Ｑ', R: 'Ｒ', S: 'Ｓ', T: 'Ｔ',
    U: 'Ｕ', V: 'Ｖ', W: 'Ｗ', X: 'Ｘ', Y: 'Ｙ', Z: 'Ｚ',
    0: '０', 1: '１', 2: '２', 3: '３', 4: '４', 5: '５', 6: '６', 7: '７', 8: '８', 9: '９'
  };

  for (const [key, value] of Object.entries(messages)) {
    if (typeof value === 'string') {
      blockified[key] = `[${value.split('').map(char => blockMap[char] || char).join('')}]`;
    } else {
      blockified[key] = value;
    }
  }
  return blockified;
}

export function pseudoTripleBracketMessages(messages: Record<string, any>): Record<string, any> {
  const bracketed: Record<string, any> = {};
  for (const [key, value] of Object.entries(messages)) {
    if (typeof value === 'string') {
      bracketed[key] = `«${value}»`;
    } else {
      bracketed[key] = value;
    }
  }
  return bracketed;
}
